import Jed from "node_modules/jed/jed";

const setup = (locale = {}, callback = () => {}) => {
	const jed = new Jed(locale);

	localize.t9n = jed.gettext.bind(jed);
	localize.nt9n = jed.ngettext.bind(jed);
	localize.mt9n = () => {};
	localize.pt9n = jed.pgettext.bind(jed);
	localize.sprintf = jed.sprintf;

	callback(localize);
};

const loaders = {
	de: () => import(/* webpackChunkName: "i18n/de.loader" */ "i18n/de.loader")
};

const localize = (localeString, callback) => {
	if (localeString in loaders) {
		const loadLanguage = loaders[localeString];
		loadLanguage().then(module => setup(module.default, callback));
	} else {
		setup({}, callback);
	}
};

export default localize;
